import {createAction} from 'redux-act';

export const CREATE_PRICE_ADJUSTMENT = createAction(
  'platformPriceAdjustments/CREATE_PRICE_ADJUSTMENT'
);
export const CREATE_PRICE_ADJUSTMENT_SUCCESS = createAction(
  'platformPriceAdjustments/CREATE_PRICE_ADJUSTMENT_SUCCESS'
);

export const DELETE_PRICE_ADJUSTMENT = createAction(
  'platformPriceAdjustments/DELETE_PRICE_ADJUSTMENT'
);
export const DELETE_PRICE_ADJUSTMENT_SUCCESS = createAction(
  'platformPriceAdjustments/DELETE_PRICE_ADJUSTMENT_SUCCESS'
);

export const RESET_ALL_PRICE_ADJUSTMENTS = createAction(
  'platformPriceAdjustments/RESET_ALL_PRICE_ADJUSTMENTS'
);
export const RESET_ALL_PRICE_ADJUSTMENTS_SUCCESS = createAction(
  'platformPriceAdjustments/RESET_ALL_PRICE_ADJUSTMENTS_SUCCESS'
);

export const OPEN_PRICE_ADJUSTMENT_MODAL = createAction(
  'platformPriceAdjustments/OPEN_PRICE_ADJUSTMENT_MODAL'
);
export const CLOSE_PRICE_ADJUSTMENT_MODAL = createAction(
  'platformPriceAdjustments/CLOSE_PRICE_ADJUSTMENT_MODAL'
);

export const SET_PRICE_ADJUSTMENT_FORM_DATA = createAction(
  'platformPriceAdjustments/SET_PRICE_ADJUSTMENT_FORM_DATA'
);
export const RESET_PRICE_ADJUSTMENT_FORM = createAction(
  'platformPriceAdjustments/RESET_PRICE_ADJUSTMENT_FORM'
);

export const GET_ALL_PRICE_ADJUSTMENTS = createAction(
  'platformPriceAdjustments/GET_ALL_PRICE_ADJUSTMENTS'
);
export const GET_ALL_PRICE_ADJUSTMENTS_SUCCESS = createAction(
  'platformPriceAdjustments/GET_ALL_PRICE_ADJUSTMENTS_SUCCESS'
);

export const SET_LOADING = createAction('platformPriceAdjustments/SET_LOADING');
